<template>
  <div class="main">
    <Navbar href="/">
      <template #back>vers Accueil</template>
      <template #title>Gestion des rôles</template>
    </Navbar>

    <div class="gestion-container">
      <div class="selectors">
        <!-- Select Rôle -->
        <div class="field">
          <label>Rôle</label>
          <select v-model="selectedGroup" @change="switch_user">
            <option value="">Sélectionner un rôle</option>
            <option v-for="group in userStore.backend_groups" :key="group" :value="group">
              {{ group }}
            </option>
          </select>
        </div>
      </div>
        <div class="create-role-button">
            <button class="primary-button" @click="CreateRoleModal()"><i class="material-icons">add_box</i>&nbsp;Créer un rôle</button>
        </div>
    </div>

    <!-- Section Rôle -->
    <Transition name="fade-slide">
      <div class="gestion-container" v-if="selectedGroup">
        <h3>Rôle sélectionné&nbsp;:&nbsp;<span>{{ selectedGroup }}</span></h3>
        <div class="button-group">
          <button class="primary-button" @click="AddRoleUser()"><i class="material-icons">person_add</i>&nbsp;Ajouter à tous</button>
          <button class="warning-button-outlined" @click="SuppRoleUser()"><i class="material-icons">person_remove</i>&nbsp;Supprimer à tous</button>
          <button class="danger-button" @click="SuppRole()"><i class="material-icons">delete</i>&nbsp;Supprimer le rôle</button>
        </div>
      </div>
    </Transition>
  </div>

  <Modal v-model="showModal">
    <CreateRole></CreateRole>
  </Modal>

    <PopUp 
        v-model:show="showPopup"
        :popupBackgroundColor="popupType === 'success' ? '#4caf50' : popupType === 'error' ? '#f44336' : '#2196f3'"
        :duration="2000"
        position="center"
        >
        <p style="color:white; font-weight:600;">{{ popupMessage }}</p>
    </PopUp>
</template>


<script setup>
import { useUserStore }   from '@/stores/userstore'
import { ref }            from 'vue'
import CreateRole         from './CreateRole.vue'
import apiClient          from '@/api'
import Navbar             from '@/components/Navbar.vue'
import Modal              from '@/components/Modal.vue'
import PopUp              from '@/components/PopUp.vue'

const userStore     = useUserStore()
const localgroups   = ref('')

const popupMessage  = ref('')
const popupType     = ref('success')
const showPopup     = ref(false)

const selectedGroup = ref('')

const showModal     = ref(false)


// ROLE FONCTION
const CreateRoleModal = () => {
    showModal.value=true
}

const SuppRole = async() => {
  if (!selectedGroup.value) return
  try {
    await apiClient.post('supp_role/', {
      role: selectedGroup.value
    });
    showPopupMessage(`Rôle "${selectedGroup.value}" supprimé avec succès.`, 'success')

    await userStore.fetchBackendGroups()
    await userStore.fetchCurrentUserGroups()

    selectedGroup.value = ''
  } catch (error) {
    showPopupMessage("Erreur lors de la suppression du rôle.", 'error')
  } 
}

// ROLE ALL USER
const AddRoleUser = async () => {
  try {
    await apiClient.post('gestion_all_role/', {
      role: selectedGroup.value,
      type : true
    });
    await userStore.fetchCurrentUserGroups()
    localgroups.value = [...userStore.current_user_groups]
    showPopupMessage(`Rôle "${selectedGroup.value}" ajouté à tous les utilisateur avec succès.`, 'success')
  } catch (error) {
    showPopupMessage("Erreur lors de l ajout du rôle à tous les utilisateurs.", 'error')
  }
}
const SuppRoleUser = async() => {
  try {
    await apiClient.post('gestion_all_role/', {
      role: selectedGroup.value,
      type : false
    });
    await userStore.fetchCurrentUserGroups()
    localgroups.value = [...userStore.current_user_groups]
    showPopupMessage(`Rôle "${selectedGroup.value}" supprimé à tous les utilisateur avec succès.`, 'success')
  } catch (error) {
    console.error(error);
    
    showPopupMessage("Erreur lors des suppressions du rôle à tous les utilisateurs.", 'error')
  }
}

const showPopupMessage = (msg, type = 'success') => {
  popupMessage.value = msg;
  popupType.value = type;
  showPopup.value = true;
}
</script>
<style scoped lang="scss">

.main {
  background-color: #fff;
  max-width: 100%;
  margin: 2rem auto;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

  height: fit-content;
}

.gestion-container {
  margin-top: 1.5rem;
  padding: 1.5rem;
  border-radius: 6px;
  background-color: $ice-blue;

  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;

    color: $dark-blue;

    span {
      color: $orange;
    }
  }

  .button-group {
    display: inline-grid;
    grid-auto-columns: max-content;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;

    button {
      justify-content: center;
      width: 100%;
    }
  }
}

.selectors {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: space-between;
}

.field {
  flex: 1;
  min-width: 250px;
  display: flex;
  flex-direction: column;

  label {
    font-weight: 600;
    margin-bottom: 0.5rem;

    color: $dark-blue;
    font-size: large;
    font-weight: bold;
  }

  select {
    padding: 0.5rem;
    border-radius: 6px;
    border: 1px solid $platinium;
    font-size: 1rem;

    background-color: #fff;
  }
}

.create-role-button {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}


.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>